import React from 'react'
import Rating from '@mui/material/Rating'
import Box from '@mui/material/Box'

const Rated = ({ value, text, classname, style }) => {
  return (
    <>
      {classname === 'countReview' ? (
        <>
          <Box
            component='fieldset'
            // mb={3}
            borderColor='transparent'
            style={{
              position: 'relative',
              marginLeft: '-10px',
              fontSize: 13,
              background: '#ffffffcc',
              style,
            }}
          >
            <Rating precision={0.5} value={value} readOnly />
            <span className={classname}>{text && text}</span>
          </Box>
        </>
      ) : (
        <>
          <Box component='fieldset' mb={3} borderColor='transparent'>
            <Rating
              precision={0.5}
              value={value}
              readOnly
              className='marating'
            />
            <p className={classname}>{text && text}</p>
          </Box>
        </>
      )}
    </>
  )
}

export default Rated
